import { createFetch } from '@vueuse/core'
import { defineStore } from 'pinia'

import { Errors } from '@/libs/error'
import router          from '@/router'
import { useAppStore } from '@/stores/app'

export const API_BASE = '/api/avtomati/v1'

/** Reads a cookie by name (the CSRF cookie is readable by design). */
export const readCookie = (name: string): string => {
    const match = document.cookie.split('; ').find((c) => c.startsWith(`${name}=`))
    return match ? decodeURIComponent(match.slice(name.length + 1)) : ''
}

// DEVIATION from the house JWT pattern (vue-spec bootstrap.md step 16): the spec (§3.5, §11)
// requires an HttpOnly session cookie plus CSRF protection, so no token is stored in JS.
// The browser sends `avt_session` itself; we echo the readable `avt_csrf` cookie in the
// `X-CSRF-Token` header on every state-changing request.
export const useFetchStore = defineStore('fetch', () => {
    const appStore = useAppStore()

    const fetch = createFetch({
        baseUrl: API_BASE,
        fetchOptions: {
            credentials: 'same-origin',
        },
        options: {
            updateDataOnError: true,
            beforeFetch({ options }) {
                const method = (options.method ?? 'GET').toUpperCase()
                const headers = new Headers(options.headers)
                if (method !== 'GET' && method !== 'HEAD') {
                    headers.set('X-CSRF-Token', readCookie('avt_csrf'))
                }
                options.headers = headers
                return { options }
            },
            async onFetchError(ctx) {
                const status = ctx.response?.status
                const code = (ctx.data as { error?: { code?: number } } | null)?.error?.code
                if (status === 401 && appStore.isLoggedIn()) {
                    appStore.setLogout()
                    await router.push({ name: 'login' })
                } else if (status === 403 && code === Errors.TermsRequired) {
                    if (appStore.me) appStore.me.needs_terms = true
                    await router.push({ name: 'terms-accept' })
                }
                return ctx
            },
        },
    })

    return { fetch }
})
